export default __webpack_public_path__ + "static/media/contact.a4708722.png";